export class Position {
    position: number;
    player: number;
    substitution: boolean;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/position.model.ts